export default class GlobalConfiguration {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        globalConfigurationRetrieve(id: ${id}) {
          id
          name
          desc
          val          
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.globalConfigurationRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        globalConfigurationList {
          results {
            id
            name
            desc
            val 
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.globalConfigurationList.results;
  }

  static async create(axios, name, desc, val) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        createGlobalConfiguration(newGlobalconfiguration: {
          name: "${name}", 
          desc: "${desc}",
          val: "${val}"          
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.createGlobalConfiguration.ok;
  }


  static async edit(axios, id, name, desc, val) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        updateGlobalConfiguration(newGlobalconfiguration: {
          id: ${id},
          name: "${name}", 
          desc: "${desc}",
          val: "${val}"
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.updateGlobalConfiguration.ok;
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `mutation{
        deleteGlobalConfiguration(id: ${id}){
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.deleteGlobalConfiguration.ok;
  }

}
